module.exports = "https://web-assets.ifttt.com/packs/media/partners/my_applets-fe54172a.svg";